import * as React from 'react';
import { Card, Button } from 'react-bootstrap';
import { mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';

export const PiTab: React.FC = (): React.ReactElement => {
  const styles = {
    row: {
      margin: '15px',
    },
  };

  const clicked = () => {
    console.log('RESTART clicked!');
  };

  return (
    <Card style={styles.row}>
      <Card.Header as="h5">Raspberry pi</Card.Header>
      <Card.Body>
        <Card.Title>Last resort, ehk restart aitab</Card.Title>
        <Button variant="danger" onClick={clicked}>
          <Icon path={mdiRefresh} size="1.5em" />
          Restart
        </Button>
      </Card.Body>
    </Card>
  );
};
